import { useEffect } from 'react';

export const useChartRendering = (chartState, callback) => {
  useEffect(() => {
    if (chartState !== undefined && callback) callback(true); 
    return () => {
      if (callback) callback(false) 
    };
  });
}